import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';

import {
  onCollapseOpen as _onCollapseOpen,
  hasError,
  assData,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';

import {
  defaultStatus,
  generateDefaultState as _generateDefaultState,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import {
  getCollapseOpenStatus as _getCollapseOpenStatus,
  EnumReducers,
  getState as _getState,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getHasModified as _getHasModified,
  getSubmitStamp as _getSubmitStamp,
  getLoaded as _getLoaded,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getReducer,
} from 'src/pages/SalesChannelContentEditor/slice/selectors'; //   getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,

import {
  EnumCollapseId,
  fixedCollapse,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
export { EnumCollapseId };

import { msg } from 'src/tools/message';

import {
  getFooterRequiredInfo,
  getFooter,
  postFooter,
} from '@/src/request/salesChannel/content';
import { convertDataFromServerToRedux } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
// import {
//   convertDataFromServerToRedux,
//   fixedCollapse,
// } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { get } from 'lodash';
import { ActionType } from 'src/types/common/common';
import arrayMove from 'array-move';

//import { getState as storeGetState } from 'src/store';

export const fetchFooter = createAsyncThunk(
  'fetchSalesChannelContentFooterPage',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getFooter(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitFooter = createAsyncThunk(
  'submitSalesChannelContentFooterPage',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await postFooter(body, params);
    return { response, isPrimary };
  },
);

export const fetchFooterRequiredInfo = createAsyncThunk(
  'fetchContentFooterRequiredInfo',
  async (data: any) => {
    //getButtonStyleAndDefaultData
    // const state = storeGetState();
    const { uuid } = data;
    // const { resetKey, params = {} } = data;
    const response = await getFooterRequiredInfo(uuid);
    //console.log('response', response);
    return { response };
  },
);

const _defaultState = _generateDefaultState(fixedCollapse);

const defaultState = {
  ..._defaultState,
  ...defaultStatus,
  availNavigationGroups: [],
  predefinedSocialMediaList: [],
};
//console.log('defaultState', defaultState);
const salesChannelContentFooterPage = createSlice({
  name: 'salesChannelContentFooterPage',
  initialState: defaultState,
  reducers: {
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    onFooterStyleChange(state, action) {
      state.footerStyle = { ...state.footerStyle, ...action.payload };
      state.hasModified = true;
    },
    onLocationSelectorTitleChange(state, action) {
      state.hasModified = true;
      state.locationSelector.title = action.payload;
    },
    onLocationSelectorOptionChange(state, action) {
      state.hasModified = true;
      const { type } = action.payload;
      if (type === ActionType.delete) {
        const { index } = action.payload;
        state.locationSelector.locationOptions.splice(index, 1);
      }
      if (type === ActionType.add) {
        const { target } = action.payload;
        state.locationSelector.locationOptions.push(target);
      }
      if (type === ActionType.reorder) {
        const { from, to } = action.payload;
        state.locationSelector.locationOptions = arrayMove(
          state.locationSelector.locationOptions,
          from,
          to,
        );
      }
      if (type === ActionType.modify) {
        const { index, target } = action.payload;
        //console.log('target', target);
        state.locationSelector.locationOptions[index] = {
          ...state.locationSelector.locationOptions[index],
          ...(target || {}),
        };
      }
    },
    onLanguageSelectorChange(state, action) {
      state.hasModified = true;
      state.languageSelector.title = action.payload;
    },
    onCurrencySelectorChange(state, action) {
      state.hasModified = true;
      state.currencySelector.title = action.payload;
    },
    onSocialMediaTitleChange(state, action) {
      state.hasModified = true;
      state.socialMediaMenu.title = action.payload;
    },
    onSocialMediaOptionChange(state, action) {
      state.hasModified = true;
      const { type } = action.payload;
      if (type === ActionType.delete) {
        const { index } = action.payload;
        state.socialMediaMenu.socialMediaList.splice(index, 1);
      }
      if (type === ActionType.add) {
        const { target } = action.payload;
        state.socialMediaMenu.socialMediaList.push(target);
      }
      if (type === ActionType.reorder) {
        const { from, to } = action.payload;
        state.socialMediaMenu.socialMediaList = arrayMove(
          state.socialMediaMenu.socialMediaList,
          from,
          to,
        );
      }
      if (type === ActionType.modify) {
        const { index, target } = action.payload;
        //console.log('target', target);
        state.socialMediaMenu.socialMediaList[index] = {
          ...state.socialMediaMenu.socialMediaList[index],
          ...(target || {}),
        };
      }
    },
    onFooterMenuOptionChange(state, action) {
      state.hasModified = true;
      const { type, level } = action.payload;
      const levelKey = `footerMenuColumn${level}`;
      const base = state.footerMenu[levelKey];
      if (type === ActionType.delete) {
        const { index } = action.payload;
        base.splice(index, 1);
      }
      if (type === ActionType.add) {
        const { target } = action.payload;
        state.footerMenu[levelKey] = [
          ...(state.footerMenu[levelKey] || []),
          target,
        ];
      }
      if (type === ActionType.reorder) {
        const { from, to } = action.payload;
        state.footerMenu[levelKey] = arrayMove(base, from, to);
      }
      if (type === ActionType.modify) {
        const { index, target } = action.payload;
        //console.log('target', target);
        // console.log('index,target', index, target);
        state.footerMenu[levelKey][index] = {
          ...(state.footerMenu[levelKey][index] || {}),
          ...(target || {}),
        };
      }
    },
    onFooterNotesChange(state, action) {
      state.hasModified = true;
      state.footerNotes = action.payload;
    },
    resetData(state) {
      assData(state, defaultState);
    },
    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFooter.fulfilled, (state, action) => {
      const { response, isClone, isPrimary } = action.payload;
      //  console.log('response', response);

      const _data = convertDataFromServerToRedux(response, isPrimary) || {};

      assData(state, _data);

      if (isClone) state.hasModified = true;
    });
    builder.addCase(fetchFooter.pending, (state, action) => {
      state.loaded = false;
    });
    builder.addCase(fetchFooter.rejected, (state, action) => {
      state.loaded = true;
    });
    builder.addCase(fetchFooterRequiredInfo.fulfilled, (state, action) => {
      const { response } = action.payload;
      const { availNavigationGroups, predefinedSocialMediaList } =
        response || {};
      state.availNavigationGroups = availNavigationGroups || [];
      state.predefinedSocialMediaList = predefinedSocialMediaList || [];
    });
    builder.addCase(fetchFooterRequiredInfo.pending, (state, action) => {
      state.loaded = false;
    });
    builder.addCase(fetchFooterRequiredInfo.rejected, (state, action) => {
      state.loaded = true;
    });
    builder.addCase(submitFooter.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const _data = convertDataFromServerToRedux(response, isPrimary) || {};
      msg.success('Footer has been updated');
      assData(state, { ..._data });
    });
  },
});

const getFooterStyle = () => {
  return createSelector(
    (state: any) => get(state, getReducer(EnumReducers.footer)).footerStyle,
    (footerStyle) => {
      //   console.log('footerStyle', footerStyle);
      return footerStyle;
    },
  );
};

const getLocationSelector = () => {
  return createSelector(
    (state: any) =>
      get(state, getReducer(EnumReducers.footer)).locationSelector,
    (locationSelector) => {
      //   console.log('footerStyle', footerStyle);
      return locationSelector;
    },
  );
};

const getLanguageSelector = () => {
  return createSelector(
    (state: any) =>
      get(state, getReducer(EnumReducers.footer)).languageSelector,
    (languageSelector) => {
      //   console.log('footerStyle', footerStyle);
      return languageSelector;
    },
  );
};

const getCurrencySelector = () => {
  return createSelector(
    (state: any) =>
      get(state, getReducer(EnumReducers.footer)).currencySelector,
    (currencySelector) => {
      return currencySelector;
    },
  );
};

const getSocialMediaList = () => {
  return createSelector(
    (state: any) =>
      get(state, getReducer(EnumReducers.footer)).predefinedSocialMediaList,
    (predefinedSocialMediaList) => {
      //   console.log('footerStyle', footerStyle);
      return predefinedSocialMediaList;
    },
  );
};

const getSocialMediaMenu = () => {
  return createSelector(
    (state: any) => get(state, getReducer(EnumReducers.footer)).socialMediaMenu,
    (socialMediaMenu) => {
      //   console.log('footerStyle', footerStyle);
      return socialMediaMenu;
    },
  );
};

const getNavigationList = () => {
  return createSelector(
    (state: any) =>
      get(state, getReducer(EnumReducers.footer)).availNavigationGroups,
    (availNavigationGroups) => {
      //   console.log('footerStyle', footerStyle);
      return availNavigationGroups;
    },
  );
};

const getFooterMenu = () => {
  return createSelector(
    (state: any) => get(state, getReducer(EnumReducers.footer)).footerMenu,
    (footerMenu) => {
      //   console.log('footerStyle', footerStyle);
      return footerMenu;
    },
  );
};

const getFooterNotes = () => {
  return createSelector(
    (state: any) => get(state, getReducer(EnumReducers.footer)).footerNotes,
    (footerNotes) => {
      //   console.log('footerStyle', footerStyle);
      return footerNotes;
    },
  );
};

export {
  getFooterStyle,
  getLocationSelector,
  getLanguageSelector,
  getCurrencySelector,
  getSocialMediaMenu,
  getSocialMediaList,
  getNavigationList,
  getFooterMenu,
  getFooterNotes,
};

export const {
  onFooterStyleChange,
  onCollapseOpen,
  onErrorChange,
  resetData,
  validation,
  onLocationSelectorOptionChange,
  onLocationSelectorTitleChange,
  onLanguageSelectorChange,
  onCurrencySelectorChange,
  onSocialMediaTitleChange,
  onSocialMediaOptionChange,
  onFooterMenuOptionChange,
  onFooterNotesChange,
} = salesChannelContentFooterPage.actions;

export const getLoaded = () => {
  return _getLoaded(EnumReducers.footer);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.footer);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.footer, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.footer, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.footer);
};

export const getState = () => {
  return _getState(EnumReducers.footer);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.footer);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.footer);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.footer);
};

export default salesChannelContentFooterPage.reducer;
